export default __webpack_public_path__ + "static/media/user.d5f278f8.svg";